import React from "react";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../infrastructure/components/RenderWhen";
import styles from "./DefaultSection.module.scss";
import { classNames } from "primereact/utils";
import { AppTooltip } from "../tooltip/AppTooltip";

interface IDefaultSectionProps {
  className?: string;
  headerClassName?: string;
  titleClassName?: string;
  /**
   * A plain string gets the standard header. An element is rendered as the whole
   * header instead, which means it has to carry its own titleSuffix and
   * actionButton - neither is rendered around it.
   */
  title?: string | React.ReactNode;
  /** Rendered right after the title, e.g. the number of records. */
  titleSuffix?: React.ReactNode;
  actionButton?: React.ReactNode;
  children: React.ReactNode;
  width?: number | string;
  tooltip?: string;
}

export const DefaultSection = ({
  className = "",
  headerClassName = "",
  titleClassName = "",
  title = "",
  titleSuffix,
  actionButton,
  children,
  width,
  tooltip,
}: IDefaultSectionProps) => {
  return (
    <div className={classNames(styles.root, className)} style={{ width }}>
      <RenderWhen condition={title !== ""}>
        <RenderWhen condition={isReactElement(title)}>
          <IfTrue>
            <>{title}</>
          </IfTrue>
          <IfFalse>
            <div className={classNames(styles.root_header, headerClassName)}>
              <div
                className={classNames(styles.root_header_title, titleClassName)}
              >
                {title}
                {titleSuffix}

                <AppTooltip content={tooltip} />
              </div>
              <div className={styles.root_header_button}>{actionButton}</div>
            </div>
          </IfFalse>
        </RenderWhen>
      </RenderWhen>
      {children}
    </div>
  );
};

const isReactElement = (
  element: React.ReactNode
): element is React.ReactElement => {
  return React.isValidElement(element);
};
